// extracted by mini-css-extract-plugin
module.exports = {"SectionHeading":"NotificationDashboard_SectionHeading__XGzu-","ItemHeader":"NotificationDashboard_ItemHeader__37qtO"};